import React from 'react';

import withStyles from '@material-ui/core/styles/withStyles';
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';

const styles = {
	count: {
		position: 'relative',
		padding: '19px 60px 17px 16px',
		fontSize: '16px',
		color: '#3c4858',
		backgroundColor: '#f7f7f7',
		margin: '40px 0 27px',
		borderRadius: '6px',
	},
	loadingIndicator: {
		position: 'absolute',
		top: '50%',
		transform: 'translateY(-50%)',
		right: '5px',
	}
};

class NumberActiveRegistrations extends React.Component {
	render() {
		const {
			classes,
			count,
			loading,
		} = this.props;
		const loadingIndicator = loading && <div className={classes.loadingIndicator}><LoadingIndicator /></div>
		return (
			<div className={classes.count}>
				Current number of registered Customers: <b>{count}</b>
				{loadingIndicator}
			</div>
		)
	}
}

export default withStyles(styles)(NumberActiveRegistrations);
